<template>
    <div class="div" v-if="currentJourney">
        <b-col v-if="currentJourney.return" cols="8"  md="4" class="option-pill-background border-rounded p-2 pb-3  mb-n2">
            <b-row class="goabz-button-group">
                <b-col cols="6" class="pr-0">
                    <button type="button"
                        class="btn h-auto map-button-pill option-pill"
                        :class="{'active': showingJourneyType === 'depart'}"
                        @click="handleJourneyTypeChange('depart')">
                        <strong>Outbound</strong>
                    </button>
                </b-col>
                <b-col cols="6" class="pl-1"  v-if="currentJourney.return">
                    <button type="button"
                        class="btn h-auto option-pill"
                        :class="{'active': showingJourneyType === 'return'}"
                        @click="handleJourneyTypeChange('return')">
                        <strong>Return</strong>
                    </button>
                </b-col>
            </b-row>
        </b-col>
        <google-map :polylines="polylines" :inverted="inverted" :markers="markers"> </google-map>
    </div>
</template>
<script>
import GoogleMap from '@/components/Map.vue'
import { stageTypeMarkerIcon, positionMarkerIcon } from '@/store/mapOptions'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    props: ['type'],
    components: {
        GoogleMap,
    },
    data() {
        return {
            showingJourneyType: 'depart',
            brand: whitelabel.brand,
        }
    },
    methods: {
        handleJourneyTypeChange(type) {
            this.showingJourneyType = type
            this.$emit('change-type', type)
        },
        getMarkerInfoWindowContent(marker) {
            const content = `<div class="toilet-info-window">
                <p><strong>${marker.name}</strong></p>
                <div class="icons-container">
                ${this.formatToiletIcons(this.getToiletIcons(marker))}
                </div>
                <p><strong>Opening Hours</strong></p>
                <div class="opening-times-container">
                ${this.formatOpeningTimes(marker.openingTimes)}
                </div>
                <p><small>${marker.notes ? marker.notes : ''}</small></p>
            </div>`

            return content
        },
        formatOpeningTimes(openingTimes) {
            if (!openingTimes) {
                return 'n/a'
            }
            let content = '<table class="table table-borderless" cellspacing="0" cellpadding="0">'
            let dayContent = ''
            openingTimes.forEach((item, index) => {
                if (Array.isArray(item)) {
                    const hours = `${item[0]} - ${item[1]}`
                    dayContent = `<tr>
                        <td>${moment().day(index).format('dddd')}</td>
                        <td>${hours}</td>
                    </tr>`
                } else {
                    dayContent = `<tr>
                        <td>${moment().day(index).format('dddd')}</td>
                        <td>${item}</td>
                    </tr>`
                }
                content += dayContent
            })
            content += '</table>'
            return content
        },
        getToiletIcons(marker) {
            const icons = []
            if (marker.accessible) {
                icons.push(['/img/map/accessible.png', 'Accessible'])
            }
            if (marker.allGender) {
                icons.push(['/img/map/men.png', 'Men'])
                icons.push(['/img/map/women.png', 'Women'])
            } else {
                if (marker.men) {
                    icons.push(['/img/map/men.png', 'Men'])
                }
                if (marker.women) {
                    icons.push(['/img/map/women.png', 'Women'])
                }
            }
            if (marker.babyChange) {
                icons.push(['/img/map/baby-change.png', 'Baby Change'])
            }
            if (!marker.paymentDetails) {
                icons.push(['/img/map/payment.png', 'Free'])
            }
            return icons
        },
        formatToiletIcons(icons) {
            let content = ''
            icons.forEach((icon) => {
                content += `<span class="icon-holder"><img src="${icon[0]}" class="toilet-icon"/></span> ${icon[1]}<br />`
            })
            return content
        },
    },
    mounted() {
        this.showingJourneyType = this.type
    },
    computed: {
        ...mapState([
            'currentJourney',
            'mapFilter',
        ]),
        ...mapGetters([
            'getMapIconByTransportMode',
        ]),
        polylines() {
            return [this.currentJourney[this.type].overview_polyline]
        },
        inverted() {
            return this.type === 'return'
        },
        markers() {
            const markers = []
            this.currentJourney[this.type].steps.forEach((step) => {
                markers.push({
                    position: step.start_location,
                    icon: {
                        ...stageTypeMarkerIcon,
                        url: this.getMapIconByTransportMode(step.type),
                    },
                })
            })
            if (this.mapFilter.selected === 'toilet' || this.mapFilter.selected === 'all') {
                this.currentJourney[this.type].destination_toilets.markers.forEach((marker) => {
                    markers.push({
                        position: marker.location,
                        icon: {
                            ...positionMarkerIcon,
                            url: '/img/map/toilet.png',
                        },
                        content: this.getMarkerInfoWindowContent(marker),
                    })
                })
            }
            return markers
        },
    },
}
</script>
